// src/components/operationCenter/widgets/token/derivatives/TwFundingSummaryWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import FundingSummaryCard from "@/components/tokenPage/derivatives/FundingSummaryCard";

const TwFundingSummaryWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["derivatives"]}>
        <FundingSummaryCard ticker={config.ticker.toUpperCase()} />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwFundingSummaryWidget;
